import React from 'react';
import {
  DialogTitle,
  DialogActions,
  Typography,
  Divider,
  IconButton,
} from '@mui/material';
import { CloseRounded } from '@mui/icons-material';
import infoIcon from '@src/assets/icons/info.png';
import warningIcon from '@src/assets/icons/warning.svg';

import { StyledDialog } from './index.style';

const NotificationDialogV3 = ({
  name,
  title,
  description,
  variant = 'info', // info | warning
  open,
  width,
  actionComponent,
  onClose,
  fitWidth,
  hideDangerouslySetInnerHTML,
  renderIcon,
  padding,
  paddingHeader,
  paddingAction,
  widthContent,
  maxWidth,
}) => {
  const renderIconVariant = () => {
    switch (variant) {
      case 'info':
        return infoIcon;
      case 'warning':
        return warningIcon;
      default:
        return null;
    }
  };

  const handleClose = (event, reason) => {
    if (reason === 'backdropClick') return;
    onClose(name);
  };

  return (
    <StyledDialog
      key={name}
      fitWidth={fitWidth}
      open={open}
      width={width}
      onClose={handleClose}
      padding={padding}
      paddingHeader={paddingHeader}
      paddingAction={paddingAction}
      widthContent={widthContent}
      maxWidth={maxWidth}
    >
      <div className="dialog-wrapper">
        <div className="header">
          <div className="dialog-title">
            {renderIcon
              ? renderIcon()
              : renderIconVariant() && (
                  <img src={renderIconVariant()} alt="icon" className="icon" />
                )}
            <Typography className="title">{title}</Typography>
          </div>

          <IconButton onClick={handleClose} aria-label="delete">
            <CloseRounded />
          </IconButton>
        </div>
        <Divider />

        <div className="content-wrapper">
          <DialogTitle classes={{ root: 'dialog-message' }}>
            {hideDangerouslySetInnerHTML ? (
              description
            ) : (
              <div
                className="description"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: description }}
              />
            )}
          </DialogTitle>

          {actionComponent && (
            <DialogActions classes={{ root: 'dialog-action' }}>
              {actionComponent}
            </DialogActions>
          )}
        </div>
      </div>
    </StyledDialog>
  );
};

export default NotificationDialogV3;
